export const TENANT_CONSUMPTION = 'tenant-consumption';
export const MONTHLY_ENGAGED_USERS_CONSUMPTION = 'billing-monthly-engaged-user-consumption';
export const DAILY_ACTIVE_USERS_CONSUMPTION = 'billing-daily-active-users-consumption';
export const DAILY_ENGAGED_USERS_CONSUMPTION = 'billing-daily-engaged-user-consumption';
export const DAILY_ACTIVE_USERS_PLAN_INFORMATIONS = 'billing-daily-active-users-plan-informations';
export const DAILY_ENGAGED_USERS_PLAN_INFORMATIONS = 'billing-daily-engaged-users-plan-informations';
export const SESSION_CONSUMPTION_BY_BOT_INFORMATIONS = 'billing-session-consumption-by-bot';
export const SESSION_CONSUMPTION = 'billing-session-consumption';
export const SESSION_NEW_PRICING = 'billing-new-session-pricing';
export const AGENT_CONSUMPTION = 'billing-agent-consumption';
export const UNLIMITED_AGENT_CONSUMPTION = 'billing-unlimited-agent-consumption';
export const DATA_CONSUMPTION = 'billing-data-consumption';
export const AI_SETTINGS_COPILOT = 'tenant-ai-settings-copilot';
export const CALLS_SETTINGS = 'tenant-calls-settings';
export const TRACKING_LOG = 'billing-tracking-log';
export const ENABLE_MTLS = 'enable-tenant-mtls-certificates';
export const USE_SUBSCRIPTION_REFERENCE_DATE = 'billing-use-subscription-reference-date';
export const PIPELINE_SCREENS_ENABLED = 'pipeline-enable';
export const ACCESS_GROUPS = 'portal-fragment-permission-groups-is-enabled';
export const DATABRICKS_STORAGE_TYPE_ENABLED = 'billing-databricks-storage-type-enabled';
export const ADVANCED_DEU_CONSUMPTION = 'billing-advanced-deu-consumption';
export const KNOWLEDGE_BASE_DOCUMENT_PRE_PROCESSING = 'knowledge-base-document-pre-processing';
export const ADVANCED_DEU_ENABLED = 'billing-advanced-deu-enabled';
export const AI_TOKEN_ENABLED = 'billing-ai-token-enabled';
export const DEU_AI_ENABLED = 'billing-deu-ai-enabled';
export const STUDIO_GROUNDING_PREPROCESSING_ENABLED = 'studio-grounding-preprocessing-enabled';